module.exports = __webpack_public_path__ + "img/sw2-b3.f0e8bf01.jpg";